import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ButtonType, ButtonSize } from './button.model';

export type { ButtonType, ButtonSize } from './button.model';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
})
export class ButtonComponent {
  type = input<'primary' | 'secondary' | 'danger' | 'success' | 'warning' | 'ghost'>('primary');
  text = input('');
  icon = input('');
  iconPosition = input<'left' | 'right'>('left');
  size = input<'sm' | 'md' | 'lg'>('md');
  disabled = input(false);
  fullWidth = input(false);
  color = input('');
  hoverColor = input('');
  textColor = input('');
  shadow = input('');
  hoverShadow = input('');
  fontWeight = input('');

  buttonClick = output<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (!this.disabled()) {
      this.buttonClick.emit(event);
    }
  }

  get buttonClasses(): string {
    return [
      'btn',
      `btn--${this.type()}`,
      `btn--${this.size()}`,
      this.fullWidth() ? 'btn--full' : '',
      this.disabled() ? 'btn--disabled' : '',
      this.icon() && !this.text() ? 'btn--icon-only' : '',
    ].filter(Boolean).join(' ');
  }

  get buttonStyles(): Record<string, string> {
    const styles: Record<string, string> = {};

    if (this.color()) {
      styles['--btn-color'] = this.color();
      styles['--btn-bg'] = this.color();
    }
    if (this.hoverColor()) {
      styles['--btn-hover-bg'] = this.hoverColor();
    }
    if (this.textColor()) {
      styles['--btn-text-color'] = this.textColor();
    }
    if (this.shadow()) {
      styles['--btn-shadow'] = this.shadow();
    }
    if (this.hoverShadow()) {
      styles['--btn-hover-shadow'] = this.hoverShadow();
    }
    if (this.fontWeight()) {
      styles['font-weight'] = this.fontWeight();
    }

    return styles;
  }
}
